export const WECOM_MESSAGE_TYPE_LABELS = {
  text: '文本消息',
  image: '图片消息',
  voice: '语音消息',
  video: '视频消息',
  card: '名片消息',
  location: '位置消息',
  emotion: '表情包消息',
  file: '文件消息',
  link: '链接消息',
  weapp: '小程序消息',
  chatrecord: '会话记录消息',
  revoke: '撤回消息',
  agree: '同意会话聊天内容',
  disagree: '不同意会话聊天内容',
  meeting_voice_call: '音频存档消息',
  voip_doc_share: '音频共享文档消息',
  external_redpacket: '互通红包消息',
  redpacket: '红包消息',
  sphfeed: '视频号消息',
  mixed: '混合消息',
  calendar: '日程消息',
  meeting: '会议邀请消息',
  docmsg: '在线文档消息',
  markdown: 'Markdown消息',
  news: '图文消息',
  collect: '填表消息',
  vote: '投票消息',
  qydiskfile: '微盘文件消息',
  solitaire: '接龙消息',
  note: '笔记消息',
  voiptext: '音视频通话消息',
  meeting_notification: '会议通知消息',
};

const MEDIA_URL_KEYS = ['url', 'media_url', 'file_url', 'path', 'src'];

export function getWecomMessageTypeLabel(msgtype) {
  if (!msgtype) {
    return '未知消息';
  }
  return WECOM_MESSAGE_TYPE_LABELS[msgtype] || `${msgtype}消息`;
}

export function normalizeMediaList(media) {
  if (!media) {
    return [];
  }

  if (typeof media === 'string') {
    const value = media.trim();
    if (!value) {
      return [];
    }

    if (value[0] === '[' || value[0] === '{') {
      try {
        return normalizeMediaList(JSON.parse(value));
      } catch (e) {
        return [value];
      }
    }

    return [value];
  }

  if (Array.isArray(media)) {
    return media.reduce((list, item) => list.concat(normalizeMediaList(item)), []);
  }

  if (typeof media === 'object') {
    for (const key of MEDIA_URL_KEYS) {
      if (media[key]) {
        return normalizeMediaList(media[key]);
      }
    }
  }

  return [];
}

export function normalizeMessageText(content) {
  if (content === null || content === undefined) {
    return '';
  }

  if (typeof content === 'string') {
    return content.trim();
  }

  if (typeof content === 'number' || typeof content === 'boolean') {
    return String(content);
  }

  if (typeof content === 'object') {
    return content.content || content.title || content.description || content.filename || '';
  }

  return '';
}

function getNestedText(message) {
  if (!message || !message.msgtype) {
    return '';
  }

  const payload = message[message.msgtype] || message.info || {};
  return normalizeMessageText(payload.content)
    || normalizeMessageText(payload.title)
    || normalizeMessageText(payload.description)
    || normalizeMessageText(payload.filename)
    || normalizeMessageText(payload.address)
    || normalizeMessageText(payload.feed_desc)
    || '';
}

export function formatWecomMessage(message) {
  const msgtype = message && message.msgtype ? message.msgtype : 'text';
  const typeLabel = getWecomMessageTypeLabel(msgtype);
  const content = normalizeMessageText(message && message.content) || getNestedText(message);
  const mediaList = normalizeMediaList(message && message.media);
  const nestedMediaList = normalizeMediaList(message && message[msgtype]);
  const images = mediaList.length ? mediaList : nestedMediaList;

  if (msgtype === 'text' || !message || !message.msgtype) {
    return {
      displayType: 'text',
      typeLabel,
      content,
      images: [],
    };
  }

  if (msgtype === 'image' || msgtype === 'emotion') {
    const imageList = images.length ? images : normalizeMediaList(content);
    return {
      displayType: 'image',
      typeLabel,
      content,
      images: imageList,
    };
  }

  if (msgtype === 'mixed') {
    return {
      displayType: 'mixed',
      typeLabel,
      content,
      images,
    };
  }

  return {
    displayType: 'type',
    typeLabel,
    content,
    images: [],
  };
}
